// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pm-detail-page {
  padding: 0.75rem 1.75rem 1.5rem;
}

.pm-detail-page .page-header {
  margin: 0 0 1rem;
}

.pm-detail-page .card {
  border-color: #e7edf3;
  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.04);
}

.pm-detail-page .nav-tabs {
  background: #f8fafc;
}

.pm-detail-page .nav-tabs .nav-link {
  align-items: center;
  color: #667085;
  display: inline-flex;
  font-weight: 600;
  gap: 0.35rem;
  opacity: 1;
}

.pm-detail-page .nav-tabs .nav-link:hover,
.pm-detail-page .nav-tabs .nav-link:focus {
  color: #1f8f98;
}

.pm-detail-page .nav-tabs .nav-link.active {
  background: #fff;
  color: #1f2937;
}

.pm-detail-helper {
  font-size: 0.8125rem;
}

.pm-detail-icon,
.pm-detail-activity-icon {
  align-items: center;
  border-radius: 8px;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
}

.pm-detail-icon {
  height: 44px;
  width: 44px;
}

.pm-detail-activity-icon {
  background: rgba(31, 143, 152, 0.12);
  color: #1f8f98;
  height: 32px;
  width: 32px;
}

.pm-detail-primary {
  background: rgba(31, 143, 152, 0.12);
  color: #1f8f98;
}

.pm-detail-success {
  background: rgba(0, 166, 121, 0.12);
  color: #00a679;
}

.pm-detail-warning {
  background: rgba(245, 159, 0, 0.14);
  color: #c87b00;
}

.pm-detail-info {
  background: rgba(22, 114, 185, 0.12);
  color: #1672b9;
}

.pm-detail-purple {
  background: rgba(111, 66, 193, 0.12);
  color: #6f42c1;
}

.pm-detail-danger {
  background: rgba(214, 57, 57, 0.12);
  color: #d63939;
}

.pm-detail-progress,
.pm-detail-gantt {
  height: 6px;
}

.pm-summary-card-clickable {
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.pm-summary-card-clickable:hover {
  box-shadow: 0 10px 20px rgba(16, 24, 40, 0.08);
  transform: translateY(-1px);
}

.pm-summary-card-active {
  border-color: #1f8f98 !important;
  box-shadow: 0 0 0 2px rgba(31, 143, 152, 0.18);
}

.pm-overview-summary {
  align-items: stretch;
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(0, 0.95fr) minmax(720px, 1.25fr);
}

.pm-overview-scope,
.pm-overview-facts {
  background: #fff;
  border: 1px solid #e7edf3;
  border-radius: 8px;
}

.pm-overview-scope {
  padding: 1rem 1.1rem;
}

.pm-overview-scope-text {
  color: #344054;
  font-size: 0.9375rem;
  line-height: 1.55;
}

.pm-overview-facts {
  display: grid;
  grid-template-columns: minmax(180px, 1.25fr) minmax(180px, 1.25fr) minmax(160px, 1fr) minmax(160px, 1fr);
  overflow: hidden;
  padding-top: 3.25rem;
  position: relative;
}

.pm-overview-facts-actions {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  left: 0;
  padding: 0.75rem 1rem 0;
  position: absolute;
  right: 0;
  top: 0;
}

.pm-overview-action-btn {
  font-weight: 600;
  justify-content: center;
  min-height: 34px;
  min-width: 82px;
  padding: 0.35rem 0.75rem;
}

.pm-overview-fact {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  justify-content: center;
  min-height: 110px;
  padding: 1rem 1.15rem;
}

.pm-overview-fact + .pm-overview-fact {
  border-left: 1px solid #e7edf3;
}

.pm-overview-fact span {
  color: #667085;
  font-size: 0.78rem;
  font-weight: 600;
}

.pm-overview-fact strong {
  color: #1f2937;
  font-size: 0.95rem;
}

.pm-overview-fact .form-control {
  min-width: 0;
}

.pm-detail-empty-state {
  align-items: center;
  border: 1px dashed #d8e0ea;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 260px;
  text-align: center;
}

.pm-task-toolbar {
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.pm-task-toolbar .btn-list {
  align-items: center;
}

.pm-task-sort-control {
  align-items: center;
  color: #667085;
  display: inline-flex;
  font-size: 0.75rem;
  font-weight: 600;
  gap: 0.5rem;
  margin: 0;
  white-space: nowrap;
}

.pm-task-sort-control .form-select {
  min-width: 142px;
}

.pm-task-table .btn-list {
  margin: 0;
}

.pm-task-add-btn {
  font-weight: 600;
  min-height: 32px;
  padding: 0.35rem 0.75rem;
}

.pm-task-parent-row td {
  background: #fff;
}

.pm-task-child-row td {
  background: #fbfdff;
}

.pm-task-clickable-row {
  cursor: pointer;
}

.pm-task-clickable-row:hover td {
  background: #f0f6f7;
}

.pm-task-row-dragging td {
  background: #eaf7f8;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.14);
  opacity: 0.92;
  position: relative;
  z-index: 2;
}

.pm-task-drag-handle {
  color: #667085;
  cursor: grab;
  flex-shrink: 0;
  height: 24px;
  width: 24px;
}

.pm-task-drag-handle:active {
  cursor: grabbing;
}

.pm-task-drag-handle:hover,
.pm-task-drag-handle:focus-visible {
  color: #1f8f98;
}

.pm-task-tree-spacer {
  flex-shrink: 0;
  height: 20px;
  width: 20px;
}

.pm-task-tree-spacer {
  display: inline-block;
}

.pm-task-tree-branch {
  border-bottom: 1px solid #cbd5e1;
  border-left: 1px solid #cbd5e1;
  border-bottom-left-radius: 4px;
  display: inline-block;
  flex-shrink: 0;
  height: 14px;
  margin-right: 0.15rem;
  width: 14px;
}

.pm-task-title {
  font-size: 0.875rem;
}

.pm-task-type-badge {
  font-size: 0.68rem;
}

.pm-detail-error-banner {
  border-color: #ffd8a8;
  border-left: 4px solid #f76707;
  box-shadow: 0 6px 16px rgba(16, 24, 40, 0.04);
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
}

.pm-detail-skeleton .placeholder {
  display: block;
}

.pm-kanban-board {
  display: grid;
  gap: 0.75rem;
  grid-auto-columns: minmax(220px, 1fr);
  grid-auto-flow: column;
  overflow-x: auto;
  padding-bottom: 0.25rem;
}

.pm-kanban-column {
  background: #f8fafc;
  border: 1px solid #e7edf3;
  border-radius: 8px;
  min-height: 320px;
}

.pm-kanban-header {
  align-items: center;
  border-bottom: 1px solid #e7edf3;
  display: flex;
  font-weight: 600;
  justify-content: space-between;
  padding: 0.75rem;
}

.pm-kanban-stack {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.75rem;
}

.pm-kanban-card {
  background: #fff;
  border: 1px solid #e7edf3;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(16, 24, 40, 0.04);
  color: inherit;
  padding: 0.75rem;
  text-align: left;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
  width: 100%;
}

.pm-kanban-card:hover {
  border-color: rgba(31, 143, 152, 0.35);
  box-shadow: 0 10px 20px rgba(16, 24, 40, 0.08);
  transform: translateY(-1px);
}

.pm-kanban-progress {
  height: 4px;
}

.pm-kanban-empty {
  align-items: center;
  border: 1px dashed #d8e0ea;
  border-radius: 8px;
  color: #98a2b3;
  display: flex;
  font-size: 0.8125rem;
  justify-content: center;
  min-height: 84px;
}

.pm-team-card {
  border: 1px solid #e7edf3;
  border-radius: 8px;
  height: 100%;
  padding: 1rem;
}

.pm-team-toolbar {
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.pm-team-add-btn {
  font-weight: 600;
  justify-content: center;
  min-height: 34px;
  min-width: 112px;
  padding: 0.35rem 0.75rem;
  white-space: nowrap;
}

.pm-team-mini-stat {
  background: #f8fafc;
  border: 1px solid #e7edf3;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  padding: 0.65rem;
}

.pm-team-mini-stat span {
  color: #667085;
  font-size: 0.75rem;
}

.pm-team-mini-stat strong {
  font-size: 1rem;
}

.pm-team-utilization {
  height: 5px;
}

.pm-team-task-list {
  border-top: 1px solid #edf2f7;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding-top: 0.75rem;
}

.pm-team-task-item {
  align-items: flex-start;
  display: flex;
  gap: 0.6rem;
}

.pm-team-task-dot {
  border-radius: 999px;
  flex-shrink: 0;
  height: 8px;
  margin-top: 0.45rem;
  width: 8px;
}

.pm-activity-toolbar {
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.pm-activity-timeline {
  position: relative;
}

.pm-activity-timeline::before {
  background: #e7edf3;
  bottom: 0.5rem;
  content: "";
  left: 16px;
  position: absolute;
  top: 0.5rem;
  width: 1px;
}

.pm-activity-item {
  display: flex;
  gap: 1rem;
  position: relative;
}

.pm-activity-item + .pm-activity-item {
  margin-top: 1rem;
}

.pm-activity-marker {
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.pm-activity-content {
  border: 1px solid #e7edf3;
  border-radius: 8px;
  flex: 1 1;
  padding: 1rem;
}

.pm-activity-change {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #edf2f7;
  border-radius: 8px;
  display: inline-flex;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding: 0.45rem 0.65rem;
}

.pm-activity-empty {
  align-items: center;
  border: 1px dashed #d8e0ea;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 180px;
  text-align: center;
}

.pm-gantt-toolbar {
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.pm-gantt-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.pm-gantt-legend span {
  align-items: center;
  color: #667085;
  display: inline-flex;
  font-size: 0.8125rem;
  gap: 0.35rem;
}

.pm-gantt-legend i {
  border-radius: 999px;
  display: inline-block;
  height: 8px;
  width: 8px;
}

.pm-gantt-project-board {
  border: 1px solid #e7edf3;
  border-radius: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
}

.pm-gantt-project-header,
.pm-gantt-project-row {
  display: grid;
  grid-template-columns: 260px max-content;
}

.pm-gantt-project-header {
  background: #f8fafc;
  border-bottom: 1px solid #e7edf3;
}

.pm-gantt-project-row + .pm-gantt-project-row {
  border-top: 1px solid #edf2f7;
}

.pm-gantt-project-label {
  background: #fff;
  border-right: 1px solid #e7edf3;
  box-shadow: 6px 0 10px rgba(16, 24, 40, 0.04);
  left: 0;
  padding: 0.65rem 1rem;
  position: sticky;
  z-index: 6;
}

.pm-gantt-project-header .pm-gantt-project-label {
  background: #f8fafc;
  color: #667085;
  font-size: 0.75rem;
  font-weight: 600;
  z-index: 3;
}

.pm-gantt-project-row-title {
  color: #667085;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.pm-gantt-project-dates {
  color: #667085;
  display: flex;
  flex-direction: column;
  font-size: 0.72rem;
  gap: 0.15rem;
  line-height: 1.25;
  margin-top: 0.3rem;
}

/* Track width is set inline per row (trackWidthPx) so it scales with the
   date range instead of squeezing month/date labels at any zoom level. */
.pm-gantt-project-track {
  isolation: isolate;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.pm-gantt-project-header .pm-gantt-project-track {
  height: 44px;
}

.pm-gantt-project-months {
  height: 22px;
  position: relative;
}

.pm-gantt-project-month {
  border-left: 1px solid #e7edf3;
  color: #344054;
  font-size: 0.72rem;
  font-weight: 600;
  overflow: hidden;
  padding: 0.3rem 0.5rem;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.pm-gantt-project-ticks {
  height: 22px;
  position: relative;
}

.pm-gantt-project-tick {
  border-left: 1px solid #f0f4f8;
  color: #98a2b3;
  font-size: 0.68rem;
  padding: 0.2rem 0 0 0.3rem;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.pm-gantt-project-row .pm-gantt-project-track {
  background-image: repeating-linear-gradient(to right, #edf2f7 0, #edf2f7 1px, transparent 1px, transparent var(--gantt-week-px, 210px));
  min-height: 60px;
}

.pm-gantt-project-bar {
  align-items: center;
  border-radius: 999px;
  box-shadow: 0 6px 14px rgba(16, 24, 40, 0.12);
  color: #fff;
  display: flex;
  height: 18px;
  justify-content: center;
  max-width: 100%;
  position: absolute;
  top: 14px;
  z-index: 2;
}

.pm-gantt-project-bar-pct {
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0 0.5rem;
  white-space: nowrap;
}

.pm-gantt-project-bar-pct-outside {
  align-items: center;
  background: #fff;
  border: 1px solid #e7edf3;
  border-radius: 999px;
  box-shadow: 0 4px 10px rgba(16, 24, 40, 0.08);
  color: #344054;
  display: inline-flex;
  font-size: 0.68rem;
  font-weight: 700;
  height: 18px;
  left: calc(100% + 6px);
  padding: 0 0.4rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
}

.pm-gantt-project-actual {
  background: rgba(16, 24, 40, 0.55);
  border-radius: 999px;
  height: 6px;
  position: absolute;
  top: 38px;
}

.pm-gantt-project-row-project .pm-gantt-project-label {
  background: #f2fafb;
}

.pm-gantt-project-row-project .pm-gantt-project-track {
  min-height: 46px;
}

.pm-gantt-project-bar-project {
  background: linear-gradient(90deg, #0d3d42, #1f8f98);
  height: 18px;
  top: 14px;
}

.pm-gantt-project-row-child .pm-gantt-project-label {
  padding-left: 1.75rem;
}

.pm-task-modal {
  z-index: 1060;
}

.pm-manual-log-modal {
  z-index: 1080;
}

.pm-manual-log-backdrop {
  z-index: 1075;
}

.pm-task-modal-stat {
  border: 1px solid #e7edf3;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-height: 72px;
  padding: 0.75rem;
}

.pm-task-modal-stat span:first-child {
  color: #667085;
  font-size: 0.8125rem;
}

.pm-task-drawer {
  background: #fff;
  bottom: 0;
  box-shadow: -18px 0 40px rgba(16, 24, 40, 0.18);
  display: flex;
  flex-direction: column;
  max-width: 560px;
  position: fixed;
  right: 0;
  top: 0;
  width: min(560px, 100vw);
  z-index: 1065;
}

.pm-task-drawer-backdrop {
  background: rgba(15, 23, 42, 0.28);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1060;
}

.pm-task-drawer-header {
  align-items: flex-start;
  background: #fff;
  border-bottom: 1px solid #e7edf3;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 1.1rem 1.2rem;
}

.pm-task-drawer-heading {
  display: flex;
  gap: 0.8rem;
  min-width: 0;
}

.pm-task-drawer-icon {
  align-items: center;
  background: #e9f7f8;
  border-radius: 8px;
  color: #1f8f98;
  display: flex;
  flex: 0 0 42px;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.pm-task-drawer-title {
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.35;
  margin: 0;
}

.pm-task-title-input {
  font-size: 1.05rem;
  font-weight: 700;
  min-height: 40px;
}

.pm-task-breadcrumb {
  display: flex;
  flex-wrap: wrap;
  font-size: 0.75rem;
  gap: 0.35rem;
  margin-top: 0.35rem;
}

.pm-task-breadcrumb button {
  background: none;
  border: 0;
  color: #1f8f98;
  max-width: 180px;
  overflow: hidden;
  padding: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pm-task-breadcrumb button:hover {
  color: #176d74;
  text-decoration: underline;
}

.pm-task-drawer-body {
  background: #f8fafc;
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem;
}

.pm-task-drawer-hero {
  background: #ffffff;
  border: 1px solid #d9edf0;
  border-radius: 8px;
  box-shadow: 0 8px 18px rgba(16, 24, 40, 0.04);
  margin-bottom: 1rem;
  padding: 1rem;
}

.pm-task-drawer-progress {
  color: #667085;
  font-size: 0.8125rem;
  margin-top: 0.95rem;
  outline: none;
}

.pm-task-drawer-progress-clickable {
  background: rgba(31, 143, 152, 0.045);
  border: 1px dashed rgba(31, 143, 152, 0.35);
  border-radius: 8px;
  cursor: pointer;
  padding: 0.5rem 0.6rem;
  transition: background-color 0.16s ease, border-color 0.16s ease;
}

.pm-task-drawer-progress-clickable .progress {
  transition: box-shadow 0.16s ease, transform 0.16s ease;
}

.pm-task-drawer-progress-clickable:hover,
.pm-task-drawer-progress-clickable:focus-visible {
  background: rgba(31, 143, 152, 0.09);
  border-color: rgba(31, 143, 152, 0.6);
}

.pm-task-drawer-progress-clickable:hover .progress,
.pm-task-drawer-progress-clickable:focus-visible .progress {
  box-shadow: 0 0 0 4px rgba(31, 143, 152, 0.12);
  transform: translateY(-1px);
}

.pm-task-drawer-progress-readonly {
  cursor: default;
  padding: 0.5rem 0.6rem;
}

.pm-task-progress-hint {
  align-items: center;
  color: #1f8f98;
  display: flex;
  font-size: 0.7rem;
  font-weight: 600;
  gap: 0.3rem;
  justify-content: flex-end;
  line-height: 1;
  margin-top: 0.45rem;
}

.pm-task-drawer-progress strong {
  color: #1f2937;
}

.pm-task-status-inline {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.pm-task-status-select {
  border: none;
  cursor: pointer;
  font-size: 0.8125rem;
  font-weight: 600;
  transition: box-shadow 0.16s ease;
  width: auto;
}

.pm-task-status-select:hover:not(:disabled),
.pm-task-status-select:focus-visible:not(:disabled) {
  box-shadow: 0 0 0 2px rgba(31, 143, 152, 0.25);
}

.pm-task-status-select:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.pm-task-status-hint {
  font-size: 0.72rem;
  white-space: nowrap;
}

.pm-task-timer {
  align-items: center;
  background: #fff;
  border: 1px solid #e7edf3;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-bottom: 1rem;
  padding: 0.65rem 0.85rem;
}

.pm-task-timer-active {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.pm-task-timer-display {
  align-items: center;
  color: #1f8f98;
  display: inline-flex;
  font-size: 0.95rem;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  gap: 0.35rem;
}

.pm-task-timer-note {
  max-width: 220px;
  min-width: 140px;
}

.pm-task-clockin-btn {
  font-weight: 600;
}

.pm-task-timer-locked {
  align-items: center;
  color: #98a2b3;
  display: inline-flex;
  font-size: 0.8125rem;
  gap: 0.4rem;
}

.pm-task-timer-error {
  flex-basis: 100%;
  font-size: 0.75rem;
}

.pm-task-timelog-table {
  font-size: 0.8125rem;
}

.pm-task-drawer-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-bottom: 1rem;
}

.pm-task-drawer-section {
  background: #fff;
  border: 1px solid #e7edf3;
  border-radius: 8px;
  padding: 1rem;
}

.pm-task-drawer-section + .pm-task-drawer-section {
  margin-top: 1rem;
}

.pm-task-drawer-section-head {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  margin-bottom: 0.85rem;
}

.pm-task-drawer-grid {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.pm-task-drawer-grid > div {
  background: #fbfcfe;
  border: 1px solid #eef2f7;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  justify-content: center;
  min-width: 0;
  padding: 0.75rem;
}

.pm-task-drawer-grid .form-control,
.pm-task-drawer-grid .form-select,
.pm-task-drawer-grid .pm-combo-select__control {
  min-height: 38px;
}

.pm-task-drawer-grid .pm-combo-select__value-container {
  padding: 0.2rem 0.45rem;
}

.pm-task-drawer-grid span:first-child {
  color: #667085;
  font-size: 0.75rem;
}

.pm-task-drawer-grid strong {
  align-items: center;
  color: #1f2937;
  display: inline-flex;
  font-size: 0.875rem;
  gap: 0.4rem;
  min-width: 0;
}

.pm-task-assignee > span {
  align-items: center;
  background: #e9eef5;
  border-radius: 999px;
  color: #536174;
  display: inline-flex;
  flex: 0 0 24px;
  font-size: 0.75rem;
  height: 24px;
  justify-content: center;
  width: 24px;
}

.pm-task-description {
  color: #536174;
  line-height: 1.55;
  white-space: pre-wrap;
}

.pm-task-drawer-empty {
  background: #fbfcfe;
  border: 1px dashed #d8e0ea;
  border-radius: 8px;
  color: #667085;
  font-size: 0.8125rem;
  padding: 1rem;
  text-align: center;
}

.pm-task-drawer-subtasks {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.pm-task-drawer-subtasks button {
  align-items: center;
  background: #fff;
  border: 1px solid #e7edf3;
  border-radius: 8px;
  color: inherit;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0.75rem;
  text-align: left;
}

.pm-task-drawer-subtasks button strong {
  color: #1f2937;
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.35;
}

.pm-task-drawer-subtasks button span span,
.pm-task-drawer-subtasks button div > span {
  color: #667085;
  display: block;
  font-size: 0.75rem;
  margin-top: 0.15rem;
}

.pm-task-drawer-subtasks button:hover {
  border-color: rgba(31, 143, 152, 0.45);
  box-shadow: 0 8px 20px rgba(16, 24, 40, 0.06);
  transform: translateY(-1px);
}

.pm-task-activity-list {
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  max-height: 320px;
  overflow-y: auto;
  padding: 0;
}

.pm-task-activity-item {
  display: flex;
  gap: 0.65rem;
  padding: 0.55rem 0;
  position: relative;
}

.pm-task-activity-item + .pm-task-activity-item {
  border-top: 1px solid #f1f4f8;
}

.pm-task-activity-dot {
  align-items: center;
  border-radius: 999px;
  display: inline-flex;
  flex: 0 0 26px;
  height: 26px;
  justify-content: center;
  width: 26px;
}

.pm-task-activity-body {
  min-width: 0;
}

.pm-task-activity-desc {
  color: #1f2937;
  font-size: 0.8125rem;
  line-height: 1.45;
  word-break: break-word;
}

.pm-task-activity-time {
  font-size: 0.7rem;
  margin-top: 0.15rem;
}

@media (max-width: 767.98px) {
  .pm-task-drawer {
    max-width: none;
    width: 100vw;
  }

  .pm-task-drawer-grid {
    grid-template-columns: 1fr;
  }
}

@keyframes pm-detail-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.pm-detail-spin {
  animation: pm-detail-spin 1s linear infinite;
}

.pm-progress-dashboard .progress {
  height: 0.55rem;
}

.pm-plan-actual-chart {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e7edf3;
  border-radius: 8px;
  padding: 1rem;
}

.pm-plan-actual-chart-head {
  align-items: flex-start;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 0.85rem;
}

.pm-plan-actual-gap {
  background: #ffffff;
  border: 1px solid #e7edf3;
  border-radius: 8px;
  color: #667085;
  font-size: 0.8125rem;
  padding: 0.45rem 0.7rem;
  white-space: nowrap;
}

.pm-plan-actual-plot {
  height: 180px;
  position: relative;
}

.pm-plan-actual-plot svg {
  display: block;
  height: 100%;
  overflow: visible;
  width: 100%;
}

.pm-plan-actual-grid {
  stroke: #e7edf3;
  stroke-width: 0.6;
}

.pm-plan-actual-area {
  opacity: 0.14;
}

.pm-plan-area {
  fill: #1672b9;
}

.pm-actual-area {
  fill: #00a679;
}

.pm-plan-actual-line {
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2.8;
  vector-effect: non-scaling-stroke;
}

.pm-plan-line {
  stroke: #1672b9;
}

.pm-actual-line {
  stroke: #00a679;
}

.pm-plan-actual-xaxis {
  display: flex;
  justify-content: space-between;
  margin-top: 0.65rem;
}

.pm-plan-actual-xaxis span {
  color: #667085;
  font-size: 0.72rem;
  font-weight: 600;
  white-space: nowrap;
}

.pm-timeline-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.9rem;
}

.pm-timeline-legend span {
  align-items: center;
  color: #667085;
  display: inline-flex;
  font-size: 0.8125rem;
  gap: 0.35rem;
}

.pm-timeline-legend i {
  border-radius: 999px;
  display: inline-block;
  height: 8px;
  width: 20px;
}

.pm-timeline-plan-dot,
.pm-timeline-plan {
  background: #1672b9;
}

.pm-timeline-actual-dot,
.pm-timeline-actual {
  background: #00a679;
}

.pm-timeline-today-dot,
.pm-timeline-open {
  background: repeating-linear-gradient(
    90deg,
    #00a679 0,
    #00a679 6px,
    rgba(0, 166, 121, 0.35) 6px,
    rgba(0, 166, 121, 0.35) 10px
  );
}

.pm-timeline-axis {
  border-bottom: 1px solid #e7edf3;
  height: 28px;
  margin-left: 190px;
  position: relative;
}

.pm-timeline-axis span {
  color: #667085;
  font-size: 0.72rem;
  font-weight: 600;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  white-space: nowrap;
}

.pm-timeline-list {
  min-width: 640px;
}

.pm-timeline-row {
  align-items: center;
  border-bottom: 1px solid #edf2f7;
  display: grid;
  gap: 1rem;
  grid-template-columns: 174px minmax(420px, 1fr);
  min-height: 64px;
  padding: 0.65rem 0;
}

.pm-timeline-label {
  min-width: 0;
}

.pm-timeline-track {
  background: #f8fafc;
  border: 1px solid #edf2f7;
  border-radius: 8px;
  height: 42px;
  overflow: hidden;
  position: relative;
}

.pm-timeline-gridline {
  background: #e7edf3;
  bottom: 0;
  position: absolute;
  top: 0;
  width: 1px;
}

.pm-timeline-bar {
  border-radius: 999px;
  box-shadow: 0 4px 10px rgba(16, 24, 40, 0.08);
  height: 10px;
  min-width: 10px;
  position: absolute;
}

.pm-timeline-plan {
  top: 8px;
}

.pm-timeline-actual {
  bottom: 8px;
}

@media (min-width: 768px) and (max-width: 1199.98px) {
  .pm-detail-page {
    padding: 1rem;
  }

  .pm-detail-page .page-header .row {
    row-gap: 1rem;
  }

  .pm-detail-page .page-header .col-auto {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
  }

  .pm-detail-page .page-header .btn-list {
    justify-content: flex-start;
  }

  .pm-detail-page .nav-tabs {
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-gutter: stable;
    -webkit-overflow-scrolling: touch;
  }

  .pm-detail-page .nav-tabs .nav-link {
    flex: 0 0 auto;
    white-space: nowrap;
  }

  .pm-overview-summary {
    grid-template-columns: 1fr;
  }

  .pm-overview-facts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    min-width: 0;
    padding-top: 3.4rem;
  }

  .pm-overview-fact + .pm-overview-fact {
    border-left: 0;
    border-top: 1px solid #e7edf3;
  }

  .pm-task-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .pm-task-toolbar .btn-list {
    justify-content: flex-start;
  }

  .pm-kanban-board {
    grid-auto-columns: minmax(260px, 34vw);
  }

  .pm-gantt-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }

  .pm-gantt-project-board {
    scrollbar-gutter: stable;
  }

  .pm-timeline-compare {
    overflow-x: auto;
    scrollbar-gutter: stable;
  }
}

@media (max-width: 767.98px) {
  .pm-detail-page {
    padding: 1rem;
  }

  .pm-overview-summary,
  .pm-overview-facts {
    grid-template-columns: 1fr;
  }

  .pm-overview-fact + .pm-overview-fact {
    border-left: 0;
    border-top: 1px solid #e7edf3;
  }

  .pm-timeline-compare {
    overflow-x: auto;
  }

  .pm-timeline-axis {
    margin-left: 174px;
    min-width: 420px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PmProjectDetail/PmProjectDetail.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,8DAA8D;AAChE;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,wGAAwG;EACxG,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,OAAO;EACP,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,6CAA6C;EAC7C,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;EAC7C,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gFAAgF;EAChF,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,6CAA6C;EAC7C,OAAO;EACP,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;yEACyE;AACzE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,uIAAuI;EACvI,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;EAC7C,WAAW;EACX,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,6CAA6C;EAC7C,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,MAAM;EACN,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,SAAS;EACT,OAAO;EACP,eAAe;EACf,QAAQ;EACR,MAAM;EACN,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,gEAAgE;AAClE;;AAEA;EACE,uDAAuD;AACzD;;AAEA;;EAEE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;;EAEE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;EACjC,WAAW;AACb;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE;;;;;;GAMC;AACH;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,+CAA+C;EAC/C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;EAC7C,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;IAChD,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF","sourcesContent":[".pm-detail-page {\n  padding: 0.75rem 1.75rem 1.5rem;\n}\n\n.pm-detail-page .page-header {\n  margin: 0 0 1rem;\n}\n\n.pm-detail-page .card {\n  border-color: #e7edf3;\n  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.04);\n}\n\n.pm-detail-page .nav-tabs {\n  background: #f8fafc;\n}\n\n.pm-detail-page .nav-tabs .nav-link {\n  align-items: center;\n  color: #667085;\n  display: inline-flex;\n  font-weight: 600;\n  gap: 0.35rem;\n  opacity: 1;\n}\n\n.pm-detail-page .nav-tabs .nav-link:hover,\n.pm-detail-page .nav-tabs .nav-link:focus {\n  color: #1f8f98;\n}\n\n.pm-detail-page .nav-tabs .nav-link.active {\n  background: #fff;\n  color: #1f2937;\n}\n\n.pm-detail-helper {\n  font-size: 0.8125rem;\n}\n\n.pm-detail-icon,\n.pm-detail-activity-icon {\n  align-items: center;\n  border-radius: 8px;\n  display: inline-flex;\n  flex-shrink: 0;\n  justify-content: center;\n}\n\n.pm-detail-icon {\n  height: 44px;\n  width: 44px;\n}\n\n.pm-detail-activity-icon {\n  background: rgba(31, 143, 152, 0.12);\n  color: #1f8f98;\n  height: 32px;\n  width: 32px;\n}\n\n.pm-detail-primary {\n  background: rgba(31, 143, 152, 0.12);\n  color: #1f8f98;\n}\n\n.pm-detail-success {\n  background: rgba(0, 166, 121, 0.12);\n  color: #00a679;\n}\n\n.pm-detail-warning {\n  background: rgba(245, 159, 0, 0.14);\n  color: #c87b00;\n}\n\n.pm-detail-info {\n  background: rgba(22, 114, 185, 0.12);\n  color: #1672b9;\n}\n\n.pm-detail-purple {\n  background: rgba(111, 66, 193, 0.12);\n  color: #6f42c1;\n}\n\n.pm-detail-danger {\n  background: rgba(214, 57, 57, 0.12);\n  color: #d63939;\n}\n\n.pm-detail-progress,\n.pm-detail-gantt {\n  height: 6px;\n}\n\n.pm-summary-card-clickable {\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;\n}\n\n.pm-summary-card-clickable:hover {\n  box-shadow: 0 10px 20px rgba(16, 24, 40, 0.08);\n  transform: translateY(-1px);\n}\n\n.pm-summary-card-active {\n  border-color: #1f8f98 !important;\n  box-shadow: 0 0 0 2px rgba(31, 143, 152, 0.18);\n}\n\n.pm-overview-summary {\n  align-items: stretch;\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: minmax(0, 0.95fr) minmax(720px, 1.25fr);\n}\n\n.pm-overview-scope,\n.pm-overview-facts {\n  background: #fff;\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n}\n\n.pm-overview-scope {\n  padding: 1rem 1.1rem;\n}\n\n.pm-overview-scope-text {\n  color: #344054;\n  font-size: 0.9375rem;\n  line-height: 1.55;\n}\n\n.pm-overview-facts {\n  display: grid;\n  grid-template-columns: minmax(180px, 1.25fr) minmax(180px, 1.25fr) minmax(160px, 1fr) minmax(160px, 1fr);\n  overflow: hidden;\n  padding-top: 3.25rem;\n  position: relative;\n}\n\n.pm-overview-facts-actions {\n  align-items: center;\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n  left: 0;\n  padding: 0.75rem 1rem 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.pm-overview-action-btn {\n  font-weight: 600;\n  justify-content: center;\n  min-height: 34px;\n  min-width: 82px;\n  padding: 0.35rem 0.75rem;\n}\n\n.pm-overview-fact {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  justify-content: center;\n  min-height: 110px;\n  padding: 1rem 1.15rem;\n}\n\n.pm-overview-fact + .pm-overview-fact {\n  border-left: 1px solid #e7edf3;\n}\n\n.pm-overview-fact span {\n  color: #667085;\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n.pm-overview-fact strong {\n  color: #1f2937;\n  font-size: 0.95rem;\n}\n\n.pm-overview-fact .form-control {\n  min-width: 0;\n}\n\n.pm-detail-empty-state {\n  align-items: center;\n  border: 1px dashed #d8e0ea;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 260px;\n  text-align: center;\n}\n\n.pm-task-toolbar {\n  align-items: center;\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.pm-task-toolbar .btn-list {\n  align-items: center;\n}\n\n.pm-task-sort-control {\n  align-items: center;\n  color: #667085;\n  display: inline-flex;\n  font-size: 0.75rem;\n  font-weight: 600;\n  gap: 0.5rem;\n  margin: 0;\n  white-space: nowrap;\n}\n\n.pm-task-sort-control .form-select {\n  min-width: 142px;\n}\n\n.pm-task-table .btn-list {\n  margin: 0;\n}\n\n.pm-task-add-btn {\n  font-weight: 600;\n  min-height: 32px;\n  padding: 0.35rem 0.75rem;\n}\n\n.pm-task-parent-row td {\n  background: #fff;\n}\n\n.pm-task-child-row td {\n  background: #fbfdff;\n}\n\n.pm-task-clickable-row {\n  cursor: pointer;\n}\n\n.pm-task-clickable-row:hover td {\n  background: #f0f6f7;\n}\n\n.pm-task-row-dragging td {\n  background: #eaf7f8;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.14);\n  opacity: 0.92;\n  position: relative;\n  z-index: 2;\n}\n\n.pm-task-drag-handle {\n  color: #667085;\n  cursor: grab;\n  flex-shrink: 0;\n  height: 24px;\n  width: 24px;\n}\n\n.pm-task-drag-handle:active {\n  cursor: grabbing;\n}\n\n.pm-task-drag-handle:hover,\n.pm-task-drag-handle:focus-visible {\n  color: #1f8f98;\n}\n\n.pm-task-tree-spacer {\n  flex-shrink: 0;\n  height: 20px;\n  width: 20px;\n}\n\n.pm-task-tree-spacer {\n  display: inline-block;\n}\n\n.pm-task-tree-branch {\n  border-bottom: 1px solid #cbd5e1;\n  border-left: 1px solid #cbd5e1;\n  border-bottom-left-radius: 4px;\n  display: inline-block;\n  flex-shrink: 0;\n  height: 14px;\n  margin-right: 0.15rem;\n  width: 14px;\n}\n\n.pm-task-title {\n  font-size: 0.875rem;\n}\n\n.pm-task-type-badge {\n  font-size: 0.68rem;\n}\n\n.pm-detail-error-banner {\n  border-color: #ffd8a8;\n  border-left: 4px solid #f76707;\n  box-shadow: 0 6px 16px rgba(16, 24, 40, 0.04);\n  margin-bottom: 1rem;\n  padding: 0.75rem 1rem;\n}\n\n.pm-detail-skeleton .placeholder {\n  display: block;\n}\n\n.pm-kanban-board {\n  display: grid;\n  gap: 0.75rem;\n  grid-auto-columns: minmax(220px, 1fr);\n  grid-auto-flow: column;\n  overflow-x: auto;\n  padding-bottom: 0.25rem;\n}\n\n.pm-kanban-column {\n  background: #f8fafc;\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  min-height: 320px;\n}\n\n.pm-kanban-header {\n  align-items: center;\n  border-bottom: 1px solid #e7edf3;\n  display: flex;\n  font-weight: 600;\n  justify-content: space-between;\n  padding: 0.75rem;\n}\n\n.pm-kanban-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 0.75rem;\n}\n\n.pm-kanban-card {\n  background: #fff;\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(16, 24, 40, 0.04);\n  color: inherit;\n  padding: 0.75rem;\n  text-align: left;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;\n  width: 100%;\n}\n\n.pm-kanban-card:hover {\n  border-color: rgba(31, 143, 152, 0.35);\n  box-shadow: 0 10px 20px rgba(16, 24, 40, 0.08);\n  transform: translateY(-1px);\n}\n\n.pm-kanban-progress {\n  height: 4px;\n}\n\n.pm-kanban-empty {\n  align-items: center;\n  border: 1px dashed #d8e0ea;\n  border-radius: 8px;\n  color: #98a2b3;\n  display: flex;\n  font-size: 0.8125rem;\n  justify-content: center;\n  min-height: 84px;\n}\n\n.pm-team-card {\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  height: 100%;\n  padding: 1rem;\n}\n\n.pm-team-toolbar {\n  align-items: center;\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.pm-team-add-btn {\n  font-weight: 600;\n  justify-content: center;\n  min-height: 34px;\n  min-width: 112px;\n  padding: 0.35rem 0.75rem;\n  white-space: nowrap;\n}\n\n.pm-team-mini-stat {\n  background: #f8fafc;\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  padding: 0.65rem;\n}\n\n.pm-team-mini-stat span {\n  color: #667085;\n  font-size: 0.75rem;\n}\n\n.pm-team-mini-stat strong {\n  font-size: 1rem;\n}\n\n.pm-team-utilization {\n  height: 5px;\n}\n\n.pm-team-task-list {\n  border-top: 1px solid #edf2f7;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding-top: 0.75rem;\n}\n\n.pm-team-task-item {\n  align-items: flex-start;\n  display: flex;\n  gap: 0.6rem;\n}\n\n.pm-team-task-dot {\n  border-radius: 999px;\n  flex-shrink: 0;\n  height: 8px;\n  margin-top: 0.45rem;\n  width: 8px;\n}\n\n.pm-activity-toolbar {\n  align-items: center;\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.pm-activity-timeline {\n  position: relative;\n}\n\n.pm-activity-timeline::before {\n  background: #e7edf3;\n  bottom: 0.5rem;\n  content: \"\";\n  left: 16px;\n  position: absolute;\n  top: 0.5rem;\n  width: 1px;\n}\n\n.pm-activity-item {\n  display: flex;\n  gap: 1rem;\n  position: relative;\n}\n\n.pm-activity-item + .pm-activity-item {\n  margin-top: 1rem;\n}\n\n.pm-activity-marker {\n  flex-shrink: 0;\n  position: relative;\n  z-index: 1;\n}\n\n.pm-activity-content {\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  flex: 1;\n  padding: 1rem;\n}\n\n.pm-activity-change {\n  align-items: center;\n  background: #f8fafc;\n  border: 1px solid #edf2f7;\n  border-radius: 8px;\n  display: inline-flex;\n  gap: 0.5rem;\n  margin-top: 0.75rem;\n  padding: 0.45rem 0.65rem;\n}\n\n.pm-activity-empty {\n  align-items: center;\n  border: 1px dashed #d8e0ea;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 180px;\n  text-align: center;\n}\n\n.pm-gantt-toolbar {\n  align-items: center;\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.pm-gantt-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.pm-gantt-legend span {\n  align-items: center;\n  color: #667085;\n  display: inline-flex;\n  font-size: 0.8125rem;\n  gap: 0.35rem;\n}\n\n.pm-gantt-legend i {\n  border-radius: 999px;\n  display: inline-block;\n  height: 8px;\n  width: 8px;\n}\n\n.pm-gantt-project-board {\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  position: relative;\n}\n\n.pm-gantt-project-header,\n.pm-gantt-project-row {\n  display: grid;\n  grid-template-columns: 260px max-content;\n}\n\n.pm-gantt-project-header {\n  background: #f8fafc;\n  border-bottom: 1px solid #e7edf3;\n}\n\n.pm-gantt-project-row + .pm-gantt-project-row {\n  border-top: 1px solid #edf2f7;\n}\n\n.pm-gantt-project-label {\n  background: #fff;\n  border-right: 1px solid #e7edf3;\n  box-shadow: 6px 0 10px rgba(16, 24, 40, 0.04);\n  left: 0;\n  padding: 0.65rem 1rem;\n  position: sticky;\n  z-index: 6;\n}\n\n.pm-gantt-project-header .pm-gantt-project-label {\n  background: #f8fafc;\n  color: #667085;\n  font-size: 0.75rem;\n  font-weight: 600;\n  z-index: 3;\n}\n\n.pm-gantt-project-row-title {\n  color: #667085;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.pm-gantt-project-dates {\n  color: #667085;\n  display: flex;\n  flex-direction: column;\n  font-size: 0.72rem;\n  gap: 0.15rem;\n  line-height: 1.25;\n  margin-top: 0.3rem;\n}\n\n/* Track width is set inline per row (trackWidthPx) so it scales with the\n   date range instead of squeezing month/date labels at any zoom level. */\n.pm-gantt-project-track {\n  isolation: isolate;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n}\n\n.pm-gantt-project-header .pm-gantt-project-track {\n  height: 44px;\n}\n\n.pm-gantt-project-months {\n  height: 22px;\n  position: relative;\n}\n\n.pm-gantt-project-month {\n  border-left: 1px solid #e7edf3;\n  color: #344054;\n  font-size: 0.72rem;\n  font-weight: 600;\n  overflow: hidden;\n  padding: 0.3rem 0.5rem;\n  position: absolute;\n  top: 0;\n  white-space: nowrap;\n}\n\n.pm-gantt-project-ticks {\n  height: 22px;\n  position: relative;\n}\n\n.pm-gantt-project-tick {\n  border-left: 1px solid #f0f4f8;\n  color: #98a2b3;\n  font-size: 0.68rem;\n  padding: 0.2rem 0 0 0.3rem;\n  position: absolute;\n  top: 0;\n  white-space: nowrap;\n}\n\n.pm-gantt-project-row .pm-gantt-project-track {\n  background-image: repeating-linear-gradient(to right, #edf2f7 0, #edf2f7 1px, transparent 1px, transparent var(--gantt-week-px, 210px));\n  min-height: 60px;\n}\n\n.pm-gantt-project-bar {\n  align-items: center;\n  border-radius: 999px;\n  box-shadow: 0 6px 14px rgba(16, 24, 40, 0.12);\n  color: #fff;\n  display: flex;\n  height: 18px;\n  justify-content: center;\n  max-width: 100%;\n  position: absolute;\n  top: 14px;\n  z-index: 2;\n}\n\n.pm-gantt-project-bar-pct {\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 0 0.5rem;\n  white-space: nowrap;\n}\n\n.pm-gantt-project-bar-pct-outside {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #e7edf3;\n  border-radius: 999px;\n  box-shadow: 0 4px 10px rgba(16, 24, 40, 0.08);\n  color: #344054;\n  display: inline-flex;\n  font-size: 0.68rem;\n  font-weight: 700;\n  height: 18px;\n  left: calc(100% + 6px);\n  padding: 0 0.4rem;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  white-space: nowrap;\n}\n\n.pm-gantt-project-actual {\n  background: rgba(16, 24, 40, 0.55);\n  border-radius: 999px;\n  height: 6px;\n  position: absolute;\n  top: 38px;\n}\n\n.pm-gantt-project-row-project .pm-gantt-project-label {\n  background: #f2fafb;\n}\n\n.pm-gantt-project-row-project .pm-gantt-project-track {\n  min-height: 46px;\n}\n\n.pm-gantt-project-bar-project {\n  background: linear-gradient(90deg, #0d3d42, #1f8f98);\n  height: 18px;\n  top: 14px;\n}\n\n.pm-gantt-project-row-child .pm-gantt-project-label {\n  padding-left: 1.75rem;\n}\n\n.pm-task-modal {\n  z-index: 1060;\n}\n\n.pm-manual-log-modal {\n  z-index: 1080;\n}\n\n.pm-manual-log-backdrop {\n  z-index: 1075;\n}\n\n.pm-task-modal-stat {\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  min-height: 72px;\n  padding: 0.75rem;\n}\n\n.pm-task-modal-stat span:first-child {\n  color: #667085;\n  font-size: 0.8125rem;\n}\n\n.pm-task-drawer {\n  background: #fff;\n  bottom: 0;\n  box-shadow: -18px 0 40px rgba(16, 24, 40, 0.18);\n  display: flex;\n  flex-direction: column;\n  max-width: 560px;\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: min(560px, 100vw);\n  z-index: 1065;\n}\n\n.pm-task-drawer-backdrop {\n  background: rgba(15, 23, 42, 0.28);\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 1060;\n}\n\n.pm-task-drawer-header {\n  align-items: flex-start;\n  background: #fff;\n  border-bottom: 1px solid #e7edf3;\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  padding: 1.1rem 1.2rem;\n}\n\n.pm-task-drawer-heading {\n  display: flex;\n  gap: 0.8rem;\n  min-width: 0;\n}\n\n.pm-task-drawer-icon {\n  align-items: center;\n  background: #e9f7f8;\n  border-radius: 8px;\n  color: #1f8f98;\n  display: flex;\n  flex: 0 0 42px;\n  height: 42px;\n  justify-content: center;\n  width: 42px;\n}\n\n.pm-task-drawer-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  line-height: 1.35;\n  margin: 0;\n}\n\n.pm-task-title-input {\n  font-size: 1.05rem;\n  font-weight: 700;\n  min-height: 40px;\n}\n\n.pm-task-breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  font-size: 0.75rem;\n  gap: 0.35rem;\n  margin-top: 0.35rem;\n}\n\n.pm-task-breadcrumb button {\n  background: none;\n  border: 0;\n  color: #1f8f98;\n  max-width: 180px;\n  overflow: hidden;\n  padding: 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pm-task-breadcrumb button:hover {\n  color: #176d74;\n  text-decoration: underline;\n}\n\n.pm-task-drawer-body {\n  background: #f8fafc;\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem;\n}\n\n.pm-task-drawer-hero {\n  background: #ffffff;\n  border: 1px solid #d9edf0;\n  border-radius: 8px;\n  box-shadow: 0 8px 18px rgba(16, 24, 40, 0.04);\n  margin-bottom: 1rem;\n  padding: 1rem;\n}\n\n.pm-task-drawer-progress {\n  color: #667085;\n  font-size: 0.8125rem;\n  margin-top: 0.95rem;\n  outline: none;\n}\n\n.pm-task-drawer-progress-clickable {\n  background: rgba(31, 143, 152, 0.045);\n  border: 1px dashed rgba(31, 143, 152, 0.35);\n  border-radius: 8px;\n  cursor: pointer;\n  padding: 0.5rem 0.6rem;\n  transition: background-color 0.16s ease, border-color 0.16s ease;\n}\n\n.pm-task-drawer-progress-clickable .progress {\n  transition: box-shadow 0.16s ease, transform 0.16s ease;\n}\n\n.pm-task-drawer-progress-clickable:hover,\n.pm-task-drawer-progress-clickable:focus-visible {\n  background: rgba(31, 143, 152, 0.09);\n  border-color: rgba(31, 143, 152, 0.6);\n}\n\n.pm-task-drawer-progress-clickable:hover .progress,\n.pm-task-drawer-progress-clickable:focus-visible .progress {\n  box-shadow: 0 0 0 4px rgba(31, 143, 152, 0.12);\n  transform: translateY(-1px);\n}\n\n.pm-task-drawer-progress-readonly {\n  cursor: default;\n  padding: 0.5rem 0.6rem;\n}\n\n.pm-task-progress-hint {\n  align-items: center;\n  color: #1f8f98;\n  display: flex;\n  font-size: 0.7rem;\n  font-weight: 600;\n  gap: 0.3rem;\n  justify-content: flex-end;\n  line-height: 1;\n  margin-top: 0.45rem;\n}\n\n.pm-task-drawer-progress strong {\n  color: #1f2937;\n}\n\n.pm-task-status-inline {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.pm-task-status-select {\n  border: none;\n  cursor: pointer;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  transition: box-shadow 0.16s ease;\n  width: auto;\n}\n\n.pm-task-status-select:hover:not(:disabled),\n.pm-task-status-select:focus-visible:not(:disabled) {\n  box-shadow: 0 0 0 2px rgba(31, 143, 152, 0.25);\n}\n\n.pm-task-status-select:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.pm-task-status-hint {\n  font-size: 0.72rem;\n  white-space: nowrap;\n}\n\n.pm-task-timer {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n  margin-bottom: 1rem;\n  padding: 0.65rem 0.85rem;\n}\n\n.pm-task-timer-active {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n}\n\n.pm-task-timer-display {\n  align-items: center;\n  color: #1f8f98;\n  display: inline-flex;\n  font-size: 0.95rem;\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n  gap: 0.35rem;\n}\n\n.pm-task-timer-note {\n  max-width: 220px;\n  min-width: 140px;\n}\n\n.pm-task-clockin-btn {\n  font-weight: 600;\n}\n\n.pm-task-timer-locked {\n  align-items: center;\n  color: #98a2b3;\n  display: inline-flex;\n  font-size: 0.8125rem;\n  gap: 0.4rem;\n}\n\n.pm-task-timer-error {\n  flex-basis: 100%;\n  font-size: 0.75rem;\n}\n\n.pm-task-timelog-table {\n  font-size: 0.8125rem;\n}\n\n.pm-task-drawer-actions {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: flex-end;\n  margin-bottom: 1rem;\n}\n\n.pm-task-drawer-section {\n  background: #fff;\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  padding: 1rem;\n}\n\n.pm-task-drawer-section + .pm-task-drawer-section {\n  margin-top: 1rem;\n}\n\n.pm-task-drawer-section-head {\n  align-items: center;\n  display: flex;\n  gap: 0.75rem;\n  justify-content: space-between;\n  margin-bottom: 0.85rem;\n}\n\n.pm-task-drawer-grid {\n  display: grid;\n  gap: 0.75rem;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.pm-task-drawer-grid > div {\n  background: #fbfcfe;\n  border: 1px solid #eef2f7;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  justify-content: center;\n  min-width: 0;\n  padding: 0.75rem;\n}\n\n.pm-task-drawer-grid .form-control,\n.pm-task-drawer-grid .form-select,\n.pm-task-drawer-grid .pm-combo-select__control {\n  min-height: 38px;\n}\n\n.pm-task-drawer-grid .pm-combo-select__value-container {\n  padding: 0.2rem 0.45rem;\n}\n\n.pm-task-drawer-grid span:first-child {\n  color: #667085;\n  font-size: 0.75rem;\n}\n\n.pm-task-drawer-grid strong {\n  align-items: center;\n  color: #1f2937;\n  display: inline-flex;\n  font-size: 0.875rem;\n  gap: 0.4rem;\n  min-width: 0;\n}\n\n.pm-task-assignee > span {\n  align-items: center;\n  background: #e9eef5;\n  border-radius: 999px;\n  color: #536174;\n  display: inline-flex;\n  flex: 0 0 24px;\n  font-size: 0.75rem;\n  height: 24px;\n  justify-content: center;\n  width: 24px;\n}\n\n.pm-task-description {\n  color: #536174;\n  line-height: 1.55;\n  white-space: pre-wrap;\n}\n\n.pm-task-drawer-empty {\n  background: #fbfcfe;\n  border: 1px dashed #d8e0ea;\n  border-radius: 8px;\n  color: #667085;\n  font-size: 0.8125rem;\n  padding: 1rem;\n  text-align: center;\n}\n\n.pm-task-drawer-subtasks {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.pm-task-drawer-subtasks button {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  color: inherit;\n  display: flex;\n  gap: 0.75rem;\n  justify-content: space-between;\n  padding: 0.75rem;\n  text-align: left;\n}\n\n.pm-task-drawer-subtasks button strong {\n  color: #1f2937;\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.pm-task-drawer-subtasks button span span,\n.pm-task-drawer-subtasks button div > span {\n  color: #667085;\n  display: block;\n  font-size: 0.75rem;\n  margin-top: 0.15rem;\n}\n\n.pm-task-drawer-subtasks button:hover {\n  border-color: rgba(31, 143, 152, 0.45);\n  box-shadow: 0 8px 20px rgba(16, 24, 40, 0.06);\n  transform: translateY(-1px);\n}\n\n.pm-task-activity-list {\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  margin: 0;\n  max-height: 320px;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.pm-task-activity-item {\n  display: flex;\n  gap: 0.65rem;\n  padding: 0.55rem 0;\n  position: relative;\n}\n\n.pm-task-activity-item + .pm-task-activity-item {\n  border-top: 1px solid #f1f4f8;\n}\n\n.pm-task-activity-dot {\n  align-items: center;\n  border-radius: 999px;\n  display: inline-flex;\n  flex: 0 0 26px;\n  height: 26px;\n  justify-content: center;\n  width: 26px;\n}\n\n.pm-task-activity-body {\n  min-width: 0;\n}\n\n.pm-task-activity-desc {\n  color: #1f2937;\n  font-size: 0.8125rem;\n  line-height: 1.45;\n  word-break: break-word;\n}\n\n.pm-task-activity-time {\n  font-size: 0.7rem;\n  margin-top: 0.15rem;\n}\n\n@media (max-width: 767.98px) {\n  .pm-task-drawer {\n    max-width: none;\n    width: 100vw;\n  }\n\n  .pm-task-drawer-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@keyframes pm-detail-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.pm-detail-spin {\n  animation: pm-detail-spin 1s linear infinite;\n}\n\n.pm-progress-dashboard .progress {\n  height: 0.55rem;\n}\n\n.pm-plan-actual-chart {\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  padding: 1rem;\n}\n\n.pm-plan-actual-chart-head {\n  align-items: flex-start;\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  margin-bottom: 0.85rem;\n}\n\n.pm-plan-actual-gap {\n  background: #ffffff;\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  color: #667085;\n  font-size: 0.8125rem;\n  padding: 0.45rem 0.7rem;\n  white-space: nowrap;\n}\n\n.pm-plan-actual-plot {\n  height: 180px;\n  position: relative;\n}\n\n.pm-plan-actual-plot svg {\n  display: block;\n  height: 100%;\n  overflow: visible;\n  width: 100%;\n}\n\n.pm-plan-actual-grid {\n  stroke: #e7edf3;\n  stroke-width: 0.6;\n}\n\n.pm-plan-actual-area {\n  opacity: 0.14;\n}\n\n.pm-plan-area {\n  fill: #1672b9;\n}\n\n.pm-actual-area {\n  fill: #00a679;\n}\n\n.pm-plan-actual-line {\n  fill: none;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2.8;\n  vector-effect: non-scaling-stroke;\n}\n\n.pm-plan-line {\n  stroke: #1672b9;\n}\n\n.pm-actual-line {\n  stroke: #00a679;\n}\n\n.pm-plan-actual-xaxis {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 0.65rem;\n}\n\n.pm-plan-actual-xaxis span {\n  color: #667085;\n  font-size: 0.72rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.pm-timeline-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.9rem;\n}\n\n.pm-timeline-legend span {\n  align-items: center;\n  color: #667085;\n  display: inline-flex;\n  font-size: 0.8125rem;\n  gap: 0.35rem;\n}\n\n.pm-timeline-legend i {\n  border-radius: 999px;\n  display: inline-block;\n  height: 8px;\n  width: 20px;\n}\n\n.pm-timeline-plan-dot,\n.pm-timeline-plan {\n  background: #1672b9;\n}\n\n.pm-timeline-actual-dot,\n.pm-timeline-actual {\n  background: #00a679;\n}\n\n.pm-timeline-today-dot,\n.pm-timeline-open {\n  background: repeating-linear-gradient(\n    90deg,\n    #00a679 0,\n    #00a679 6px,\n    rgba(0, 166, 121, 0.35) 6px,\n    rgba(0, 166, 121, 0.35) 10px\n  );\n}\n\n.pm-timeline-axis {\n  border-bottom: 1px solid #e7edf3;\n  height: 28px;\n  margin-left: 190px;\n  position: relative;\n}\n\n.pm-timeline-axis span {\n  color: #667085;\n  font-size: 0.72rem;\n  font-weight: 600;\n  position: absolute;\n  top: 0;\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n\n.pm-timeline-list {\n  min-width: 640px;\n}\n\n.pm-timeline-row {\n  align-items: center;\n  border-bottom: 1px solid #edf2f7;\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: 174px minmax(420px, 1fr);\n  min-height: 64px;\n  padding: 0.65rem 0;\n}\n\n.pm-timeline-label {\n  min-width: 0;\n}\n\n.pm-timeline-track {\n  background: #f8fafc;\n  border: 1px solid #edf2f7;\n  border-radius: 8px;\n  height: 42px;\n  overflow: hidden;\n  position: relative;\n}\n\n.pm-timeline-gridline {\n  background: #e7edf3;\n  bottom: 0;\n  position: absolute;\n  top: 0;\n  width: 1px;\n}\n\n.pm-timeline-bar {\n  border-radius: 999px;\n  box-shadow: 0 4px 10px rgba(16, 24, 40, 0.08);\n  height: 10px;\n  min-width: 10px;\n  position: absolute;\n}\n\n.pm-timeline-plan {\n  top: 8px;\n}\n\n.pm-timeline-actual {\n  bottom: 8px;\n}\n\n@media (min-width: 768px) and (max-width: 1199.98px) {\n  .pm-detail-page {\n    padding: 1rem;\n  }\n\n  .pm-detail-page .page-header .row {\n    row-gap: 1rem;\n  }\n\n  .pm-detail-page .page-header .col-auto {\n    flex: 0 0 100%;\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .pm-detail-page .page-header .btn-list {\n    justify-content: flex-start;\n  }\n\n  .pm-detail-page .nav-tabs {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    overflow-y: hidden;\n    scrollbar-gutter: stable;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .pm-detail-page .nav-tabs .nav-link {\n    flex: 0 0 auto;\n    white-space: nowrap;\n  }\n\n  .pm-overview-summary {\n    grid-template-columns: 1fr;\n  }\n\n  .pm-overview-facts {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    min-width: 0;\n    padding-top: 3.4rem;\n  }\n\n  .pm-overview-fact + .pm-overview-fact {\n    border-left: 0;\n    border-top: 1px solid #e7edf3;\n  }\n\n  .pm-task-toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .pm-task-toolbar .btn-list {\n    justify-content: flex-start;\n  }\n\n  .pm-kanban-board {\n    grid-auto-columns: minmax(260px, 34vw);\n  }\n\n  .pm-gantt-toolbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .pm-gantt-project-board {\n    scrollbar-gutter: stable;\n  }\n\n  .pm-timeline-compare {\n    overflow-x: auto;\n    scrollbar-gutter: stable;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .pm-detail-page {\n    padding: 1rem;\n  }\n\n  .pm-overview-summary,\n  .pm-overview-facts {\n    grid-template-columns: 1fr;\n  }\n\n  .pm-overview-fact + .pm-overview-fact {\n    border-left: 0;\n    border-top: 1px solid #e7edf3;\n  }\n\n  .pm-timeline-compare {\n    overflow-x: auto;\n  }\n\n  .pm-timeline-axis {\n    margin-left: 174px;\n    min-width: 420px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
